<template>
  <div class="loader-container" v-if="isLoading">
    <div class="spinner">
      <svg width="64px" height="64px" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#0091f4">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)" stroke-width="2">
            <circle stroke-opacity=".25" cx="18" cy="18" r="18"/>
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.8s"
                repeatCount="indefinite"/>
            </path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  // data() {
  //   return {
  //     isLoading: false
  //   }
  // },
  props: {
    isLoading: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Loader.vue